import { __awaiter, __generator } from "tslib";
import { createElement } from '@gn-audio/core/common/templating';
import { BasketEngravingValidationMessageComponent } from '../basket-engraving-validation-message';
import { validateEngravingMessage, validateEngravingMessageLength } from './utiltities';
import './basket-engraving-input.component.scss';
import template from './basket-engraving-input.component.html';
var BasketEngravingInputComponent = /** @class */ (function () {
    function BasketEngravingInputComponent() {
        var _this = this;
        this.validationComponents = [];
        this.onEngravingMessageChange = function () { return __awaiter(_this, void 0, void 0, function () {
            var isValid;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validateMessage()];
                    case 1:
                        isValid = _a.sent();
                        if (this.onChange) {
                            this.onChange(this.input.value, isValid);
                        }
                        if (isValid) {
                            this.validationSection.innerHTML = '';
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    }
    Object.defineProperty(BasketEngravingInputComponent.prototype, "value", {
        get: function () {
            var _a;
            return (_a = this.input) === null || _a === void 0 ? void 0 : _a.value;
        },
        enumerable: false,
        configurable: true
    });
    BasketEngravingInputComponent.prototype.focus = function () {
        var _a;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.focus();
    };
    BasketEngravingInputComponent.prototype.render = function (_a) {
        var container = _a.container, data = _a.data, translations = _a.translations, onChange = _a.onChange;
        this.translations = translations;
        this.onChange = onChange;
        this.element = createElement(template, { message: (data.c_engravingMsg || '').replace(/\"/g, '&quot;') }, this.translations);
        this.input = this.element.querySelector('.basket-engraving-input__input');
        this.input.addEventListener('keyup', this.onEngravingMessageChange);
        this.validationSection = this.element.querySelector('.basket-engraving-input__validation');
        container.append(this.element);
    };
    BasketEngravingInputComponent.prototype.destroy = function () {
        var _a, _b;
        (_a = this.input) === null || _a === void 0 ? void 0 : _a.removeEventListener('keyup', this.onEngravingMessageChange);
        (_b = this.element) === null || _b === void 0 ? void 0 : _b.remove();
    };
    BasketEngravingInputComponent.prototype.validateMessage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var message, isValidValue, isValidLength;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = this.input.value;
                        return [4 /*yield*/, validateEngravingMessage(message)];
                    case 1:
                        isValidValue = _a.sent();
                        this.handleValidationMessage(isValidValue, 0 /* ValidationMessageType.NotValidValue */, this.translations.EngravingMessageInValid);
                        isValidLength = validateEngravingMessageLength(message);
                        this.handleValidationMessage(isValidLength, 1 /* ValidationMessageType.NotValidLength */, this.translations.EngravingMessageInValidLength);
                        return [2 /*return*/, isValidValue && isValidLength];
                }
            });
        });
    };
    BasketEngravingInputComponent.prototype.handleValidationMessage = function (isValid, type, validationMessage) {
        var component = this.getValidationMessage(type);
        if (!isValid) {
            if (!component) {
                this.addValidationMessage(type, validationMessage);
            }
        }
        else {
            var componentIndex = this.validationComponents.indexOf(component);
            if (componentIndex > -1) {
                this.validationComponents.splice(componentIndex, 1);
            }
            component === null || component === void 0 ? void 0 : component.destroy();
        }
    };
    BasketEngravingInputComponent.prototype.getValidationMessage = function (type) {
        return this.validationComponents.find(function (x) { return x.type === type; });
    };
    BasketEngravingInputComponent.prototype.addValidationMessage = function (type, message) {
        var component = new BasketEngravingValidationMessageComponent();
        component.render({
            container: this.validationSection,
            data: message,
            type: type,
        });
        this.validationComponents.push(component);
    };
    return BasketEngravingInputComponent;
}());
export { BasketEngravingInputComponent };
